"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TypedRecord = _interopRequireDefault(require("./TypedRecord"));

var _default = (0, _TypedRecord.default)({
  reason: _propTypes.default.any
}, 'ResolverError');

exports.default = _default;
module.exports = exports.default;